const pressReleases = require('../pages/pressreleases/pressreleases.json');

export default {
  large: [

    {
      sectionType: 'subsections',

      data: {
        color: 'offWhiteOnBlue',
        sections: [
          {
            full: {
              component: 'flex-block',
              data: {
                columns: 3,
                headerSize: 'large',
                header1: 'Press',
                text2: "<a href='https://storage.googleapis.com/spotin/doc/presskit/Spotin_Press_Kit.zip' download style='text-decoration: underline'>Download press kit here</a><br><br>Looking for something specific? Don’t hesitate to contact us at <a href='mailto:press@spotin.com?subject=Press contact (from website)' style='text-decoration:underline'>press@spotin.com</a>",
              }
            },
          }
        ]
      },
    },

    {
      sectionType: 'subsections',

      data: {
        color: 'offWhiteOnBlue',
        sections: [
          {
            full: {
              component: 'flex-block',
              data: {
                blockModifiers: ['endMargin','noColumnBottomMargin'],
                header1: 'Commerce on the<br>terms of brands,<br>publishers & people',
                text2: "<p>Spotin started as an idea to bridge the gap between exposure and sales. Today the result is not only a service adding convenience for end-consumers, but also an alternative giving the power and control back to brands and publishers/content creators.</p><p>We still put our faith in the idea of the Internet being the free market place creating equal opportunities for everyone (instead of today's system where a few big tech giants build gated</p>",
                text3: "<p>communities, setting the terms & conditions for the survival of both brands and publishers), and the idea that in the end, a system creating the best synergies between brands and publishers will be forcing a shift to a better online market.</p><p>In the end, this might be the biggest reason for why we get up in the morning, striving to overthrow a flawed system - fighting for commerce on the terms of brands, publishers, and people.</p>"
              }
            },
          }
        ]
      },
    },

    {
      sectionType: 'subsections',

      data: {
        color: 'sandOnOffBlack',
        sections: [
          {
            full: {
              component: 'press-releases',
              data: {
                blockModifiers: ['endMargin', 'alignBaseline'],
                header: 'Press releases',
                pressReleases: pressReleases.pressReleases,
                startIndex: pressReleases.pressReleases.length
              }
            },
          }
        ]
      },
    },

    // {
    //   sectionType: 'subsections',

    //   data: {
    //     color: 'offWhiteOnBlue',
    //     sections: [
    //       {
    //         top: {
    //           component: 'flex-block',
    //           data: {
    //             header1: 'Product images',
    //           }
    //         },
    //         bottom: {
    //           component: 'flex-block',
    //           data: {
    //             img1: {
    //               src: 'news2.jpg',
    //               caption: 'img1 caption',
    //             },
    //             img2: {
    //               src: 'news3.jpg',
    //               caption: 'img1 caption',
    //             },
    //             img3: {
    //               src: 'news4.jpg',
    //               caption: 'img1 caption',
    //             },
    //           }
    //         },
    //       }
    //     ]
    //   },
    // },


    // {
    //   sectionType: 'subsections',

    //   data: {
    //     color: 'offWhiteOnBlue',
    //     sections: [
    //       {
    //         full: {
    //           component: 'flex-block',
    //           data: {
    //             header1: 'People',
    //           }
    //         },
    //       }
    //     ]
    //   },
    // },

    // {
    //   sectionType: 'subsections',

    //   data: {
    //     color: 'offWhiteOnBlue',
    //     sections: [
    //       {
    //         top: {
    //           component: 'flex-block',
    //           data: {
    //             img1: {
    //               src: 'news2.jpg',
    //               caption: 'img1 caption',
    //             },
    //             img2: {
    //               src: 'news3.jpg',
    //               caption: 'img1 caption',
    //             },
    //             img3: {
    //               src: 'news4.jpg',
    //               caption: 'img1 caption',
    //             },
    //           }
    //         },
    //         bottom: {
    //           component: 'flex-block',
    //           data: {
    //             img1: {
    //               src: 'news2.jpg',
    //               caption: 'img1 caption',
    //             },
    //             img2: {
    //               src: 'news3.jpg',
    //               caption: 'img1 caption',
    //             },
    //             img3: {
    //               src: 'news4.jpg',
    //               caption: 'img1 caption',
    //             },
    //           }
    //         },
    //       }
    //     ]
    //   },
    // },


    // {
    //   sectionType: 'subsections',

    //   data: {
    //     color: 'offWhiteOnBlue',
    //     sections: [
    //       {
    //         full: {
    //           component: 'flex-block',
    //           data: {
    //             header1: 'Commerce on the terms of brands, publishers & people',
    //             text2: "TBD text goes here",
    //           }
    //         },
    //       }
    //     ]
    //   },
    // },

    // {
    //   sectionType: 'subsections',

    //   data: {
    //     color: 'offWhiteOnBlue',
    //     sections: [
    //       {
    //         top: {
    //           component: 'flex-block',
    //           data: {
    //             header1: 'Brand assets',
    //           }
    //         },
    //         bottom: {
    //           component: 'flex-block',
    //           data: {
    //             img1: {
    //               src: 'news2.jpg',
    //               caption: 'img1 caption',
    //             },
    //             img2: {
    //               src: 'news3.jpg',
    //               caption: 'img1 caption',
    //             },
    //             img3: {
    //               src: 'news4.jpg',
    //               caption: 'img1 caption',
    //             },
    //           }
    //         },
    //       }
    //     ]
    //   },
    // },

  ],
};



// WEBPACK FOOTER //
// ./pages/Press.js